"use strict";

var _interopRequireDefault3 = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault3(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault3(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault3(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault3(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault3(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault3(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault3(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault3(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault3(require("@babel/runtime/helpers/defineProperty"));

var _interopRequireDefault2 = _interopRequireDefault3(require("@babel/runtime/helpers/interopRequireDefault"));

var _autobindDecorator = _interopRequireDefault3(require("autobind-decorator"));

var _Button = _interopRequireDefault3(require("../../Button"));

var _ChevronLeftMedium = _interopRequireDefault3(require("../../Icon/core/ChevronLeftMedium"));

var _ChevronRightMedium = _interopRequireDefault3(require("../../Icon/core/ChevronRightMedium"));

var _classnames = _interopRequireDefault3(require("classnames"));

var _convertUnsafeMethod = _interopRequireDefault3(require("../../utils/convertUnsafeMethod"));

var _createId = _interopRequireDefault3(require("../../utils/createId"));

var _filterDOMProps = _interopRequireDefault3(require("../../utils/filterDOMProps"));

var _LiveRegionAnnouncer = _interopRequireDefault3(require("../../utils/LiveRegionAnnouncer"));

var _intl = require("../../utils/intl");

var _propTypes = _interopRequireDefault3(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _Textfield = _interopRequireDefault3(require("../../Textfield"));

require("../style/index.css");

var _class, _class2, _temp;

var intlMessages = {
  "cs-CZ": (0, _interopRequireDefault2["default"])(require("./../intl/cs-CZ.json"))["default"],
  "da-DK": (0, _interopRequireDefault2["default"])(require("./../intl/da-DK.json"))["default"],
  "de-DE": (0, _interopRequireDefault2["default"])(require("./../intl/de-DE.json"))["default"],
  "en-US": (0, _interopRequireDefault2["default"])(require("./../intl/en-US.json"))["default"],
  "es-ES": (0, _interopRequireDefault2["default"])(require("./../intl/es-ES.json"))["default"],
  "fi-FI": (0, _interopRequireDefault2["default"])(require("./../intl/fi-FI.json"))["default"],
  "fr-FR": (0, _interopRequireDefault2["default"])(require("./../intl/fr-FR.json"))["default"],
  "hu-HU": (0, _interopRequireDefault2["default"])(require("./../intl/hu-HU.json"))["default"],
  "it-IT": (0, _interopRequireDefault2["default"])(require("./../intl/it-IT.json"))["default"],
  "ja-JP": (0, _interopRequireDefault2["default"])(require("./../intl/ja-JP.json"))["default"],
  "ko-KR": (0, _interopRequireDefault2["default"])(require("./../intl/ko-KR.json"))["default"],
  "nb-NO": (0, _interopRequireDefault2["default"])(require("./../intl/nb-NO.json"))["default"],
  "nl-NL": (0, _interopRequireDefault2["default"])(require("./../intl/nl-NL.json"))["default"],
  "pl-PL": (0, _interopRequireDefault2["default"])(require("./../intl/pl-PL.json"))["default"],
  "pt-BR": (0, _interopRequireDefault2["default"])(require("./../intl/pt-BR.json"))["default"],
  "ru-RU": (0, _interopRequireDefault2["default"])(require("./../intl/ru-RU.json"))["default"],
  "sv-SE": (0, _interopRequireDefault2["default"])(require("./../intl/sv-SE.json"))["default"],
  "tr-TR": (0, _interopRequireDefault2["default"])(require("./../intl/tr-TR.json"))["default"],
  "uk-UA": (0, _interopRequireDefault2["default"])(require("./../intl/uk-UA.json"))["default"],
  "zh-CN": (0, _interopRequireDefault2["default"])(require("./../intl/zh-CN.json"))["default"],
  "zh-TW": (0, _interopRequireDefault2["default"])(require("./../intl/zh-TW.json"))["default"]
};

if (process.env.SCALE_MEDIUM && process.env.SCALE_LARGE) {
  require("../../spectrum-css/pagination/index.css");

  require("../../spectrum-css/pagination/index-diff.css");
} else if (process.env.SCALE_LARGE) {
  require("../../spectrum-css/pagination/index-lg.css");
} else {
  require("../../spectrum-css/pagination/index.css");
}

if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_LIGHT) require("../../spectrum-css/pagination/multiStops/light.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_DARK) require("../../spectrum-css/pagination/multiStops/dark.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_LIGHTEST) require("../../spectrum-css/pagination/multiStops/lightest.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_DARKEST) require("../../spectrum-css/pagination/multiStops/darkest.css");

if (process.env.SCALE_MEDIUM && process.env.SCALE_LARGE) {
  require("../../spectrum-css-overrides/splitbutton/index.css");

  require("../../spectrum-css-overrides/splitbutton/index-diff.css");
} else if (process.env.SCALE_LARGE) {
  require("../../spectrum-css-overrides/splitbutton/index-lg.css");
} else {
  require("../../spectrum-css-overrides/splitbutton/index.css");
}

var formatMessage = (0, _intl.messageFormatter)(intlMessages);

var Pagination = (0, _convertUnsafeMethod["default"])(_class = (0, _autobindDecorator["default"])(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Pagination, _Component);

  function Pagination(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Pagination);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Pagination).call(this, props));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "defaultPage", _this.props.currentPage || _this.props.defaultPage);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      currentPage: _this.defaultPage,
      pageInput: _this.defaultPage
    });
    _this.defaultId = (0, _createId["default"])(); // ref for the Textfield element

    _this.textfieldRef;
    return _this;
  }

  (0, _createClass2["default"])(Pagination, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var currentPage = nextProps.currentPage;

      if ('currentPage' in nextProps && !this.isInvalidPage(currentPage)) {
        this.setState({
          currentPage: currentPage,
          pageInput: currentPage
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$state = this.state,
          currentPage = _this$state.currentPage,
          pageInput = _this$state.pageInput;

      if (currentPage === pageInput && pageInput !== prevState.pageInput) {
        this.announcePageInputValue(pageInput);
      }
    }
  }, {
    key: "isInvalidPage",
    value: function isInvalidPage(page) {
      var totalPages = this.props.totalPages;
      return isNaN(page) || page < 1 || totalPages && page > totalPages;
    }
  }, {
    key: "changePage",
    value: function changePage(newPage, eventToFire, event) {
      if (this.isInvalidPage(newPage)) {
        return;
      }

      var isControlled = 'currentPage' in this.props;

      if (eventToFire && newPage !== this.state.currentPage) {
        eventToFire(newPage, event);
      }

      if (!isControlled) {
        this.setState({
          currentPage: newPage,
          pageInput: newPage
        });
      } else if (isControlled && this.state.currentPage !== this.state.pageInput) {
        this.setState({
          pageInput: this.state.currentPage
        });
      }
    }
  }, {
    key: "commitPageInput",
    value: function commitPageInput(value, event) {
      this.changePage(value, this.props.onChange, event);
    }
  }, {
    key: "announcePageInputValue",
    value: function announcePageInputValue(pageNumber) {
      if (this.props.variant === 'explicit' && pageNumber !== '') {
        // Announce new value using a live region
        _LiveRegionAnnouncer["default"].announceAssertive(pageNumber.toString());
      }
    }
  }, {
    key: "onPageInputBlur",
    value: function onPageInputBlur() {
      var _this$state2 = this.state,
          currentPage = _this$state2.currentPage,
          pageInput = _this$state2.pageInput;

      if (currentPage !== pageInput) {
        this.setState({
          pageInput: currentPage
        });
      }
    }
  }, {
    key: "onPageInputChange",
    value: function onPageInputChange(value) {
      if (value === '' || !this.isInvalidPage(parseInt(value, 10))) {
        this.setState({
          pageInput: value
        });
      }
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(event) {
      var pageInput = parseInt(this.state.pageInput, 10);
      var currentPage = pageInput;

      switch (event.key) {
        case 'ArrowUp':
        case 'Up':
          this.commitPageInput(this.state.currentPage + 1, event);
          break;

        case 'ArrowDown':
        case 'Down':
          this.commitPageInput(this.state.currentPage - 1, event);
          break;

        case 'Enter':
          if (isNaN(currentPage)) {
            currentPage = this.state.currentPage;
          }

          this.commitPageInput(currentPage, event);
          break;

        case ' ':
          this.commitPageInput(currentPage, event);
          break;

        default:
          this.onPageInputChange(currentPage);
      }
    }
  }, {
    key: "onPrevious",
    value: function onPrevious(e) {
      this.changePage(this.state.currentPage - 1, this.props.onPrevious, e);
    }
  }, {
    key: "onNext",
    value: function onNext(e) {
      this.changePage(this.state.currentPage + 1, this.props.onNext, e);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          mode = _this$props.mode,
          variant = _this$props.variant,
          totalPages = _this$props.totalPages,
          _this$props$id = _this$props.id,
          id = _this$props$id === void 0 ? this.defaultId : _this$props$id,
          _this$props$ariaLabe = _this$props['aria-label'],
          ariaLabel = _this$props$ariaLabe === void 0 ? formatMessage('pagination') : _this$props$ariaLabe,
          ariaLabelledby = _this$props['aria-labelledby'],
          otherProps = (0, _objectWithoutProperties2["default"])(_this$props, ["mode", "variant", "totalPages", "id", "aria-label", "aria-labelledby"]);
      delete otherProps.onChange;
      var pageInput = this.state.pageInput;
      var isButtonMode = variant === 'button';
      var isExplicitMode = variant === 'explicit';
      var buttonVariant = isButtonMode ? mode : 'action';
      var isFirst = this.isInvalidPage(parseInt(pageInput, 10) - 1);
      var isLast = this.isInvalidPage(parseInt(pageInput, 10) + 1);
      var previousLabel = formatMessage('previous');
      var inputLabel = formatMessage('page');
      var nextLabel = formatMessage('next');
      var counterId = "".concat(id, "-counter");
      return _react["default"].createElement("nav", (0, _extends2["default"])({
        className: (0, _classnames["default"])({
          'spectrum-SplitButton': isButtonMode,
          'spectrum-SplitButton--left': isButtonMode,
          'spectrum-Pagination': !isButtonMode,
          'spectrum-Pagination--explicit': isExplicitMode
        }, 'react-spectrum-Pagination'),
        id: id,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledby
      }, (0, _filterDOMProps["default"])(otherProps)), _react["default"].createElement(_Button["default"], {
        ref: function ref(b) {
          return _this2.prevButtonRef = b;
        },
        onClick: this.onPrevious,
        variant: buttonVariant,
        quiet: !isButtonMode,
        "aria-label": isExplicitMode ? "".concat(previousLabel, ", ").concat(pageInput) : previousLabel,
        "aria-describedby": isExplicitMode ? counterId : null,
        disabled: isExplicitMode && isFirst || null,
        "aria-disabled": isButtonMode && isFirst || null,
        tabIndex: isFirst ? -1 : null,
        className: isButtonMode ? 'spectrum-SplitButton-trigger' : 'spectrum-Pagination-prevButton'
      }, _react["default"].createElement(_ChevronLeftMedium["default"], null)), isExplicitMode && [_react["default"].createElement(_Textfield["default"], {
        ref: function ref(t) {
          return _this2.textfieldRef = t;
        },
        key: 1,
        value: pageInput,
        onBlur: this.onPageInputBlur,
        onChange: this.onPageInputChange,
        onKeyDown: this.onKeyDown,
        "aria-label": inputLabel,
        "aria-describedby": counterId,
        className: "spectrum-Pagination-input"
      }), _react["default"].createElement("span", {
        key: 2,
        id: counterId,
        className: "spectrum-Body--secondary spectrum-Pagination-counter"
      }, formatMessage('page_count', {
        n: totalPages
      }))], _react["default"].createElement(_Button["default"], {
        ref: function ref(b) {
          return _this2.nextButtonRef = b;
        },
        onClick: this.onNext,
        variant: buttonVariant,
        quiet: !isButtonMode,
        "aria-label": isExplicitMode ? "".concat(nextLabel, ", ").concat(pageInput) : nextLabel,
        "aria-describedby": isExplicitMode ? counterId : null,
        disabled: isExplicitMode && isLast || null,
        "aria-disabled": isButtonMode && isLast || null,
        tabIndex: isLast ? -1 : null,
        className: isButtonMode ? 'spectrum-SplitButton-action' : 'spectrum-Pagination-nextButton'
      }, _react["default"].createElement("span", {
        className: "spectrum-Button-label"
      }, isButtonMode ? nextLabel : ''), _react["default"].createElement(_ChevronRightMedium["default"], null)));
    }
  }]);
  return Pagination;
}(_react.Component), (0, _defineProperty2["default"])(_class2, "propTypes", {
  /**
   * Button will give two button controls, one for increment and one for decrement.
   * Explicit will give a text field input that accepts numbers between 1 and totalPages.
   * When a number is typed in explicit mode, an onChange is fired only when enter is pressed.
   * If the user tabs off without hitting enter and then uses the increment button, it will resume
   * from the number it was at before the user typed anything.
   */
  variant: _propTypes["default"].oneOf(['button', 'explicit']),

  /**
   * The mode of pagination. This is purely cosmetic.
   */
  mode: _propTypes["default"].oneOf(['cta', 'primary', 'secondary']),

  /**
   * The current page number.
   */
  currentPage: _propTypes["default"].number,

  /**
   * The default page number.
   */
  defaultPage: _propTypes["default"].number,

  /**
   * The total page number. If user hits the total number, the pagination will be capped and will not
   * progress any higher. It also can't go lower than 1.
   */
  totalPages: _propTypes["default"].number,

  /**
   * The callback function when the pagination is changed. It sends the value of the new current page.
   */
  onChange: _propTypes["default"].func,

  /**
   * The callback function when the pagination is changed to previous page.
   * It sends the value of the new current page.
   */
  onPrevious: _propTypes["default"].func,

  /**
   * The callback function when the pagination is changed to next page.
   * It sends the value of the new current page.
   */
  onNext: _propTypes["default"].func
}), (0, _defineProperty2["default"])(_class2, "defaultProps", {
  variant: 'button',
  mode: 'primary',
  defaultPage: 1
}), _temp)) || _class) || _class;

exports["default"] = Pagination;
Pagination.displayName = 'Pagination';